import { writable } from 'svelte/store';

export type Route =
  | 'landing'
  | 'debugger'
  | 's3-explorer'
  | 'ddb-viewer'
  | 'log-explorer'
  | 'sqs-monitor'
  | 'lambda-inspector'
  | 'health-dashboard'
  | 'strategy-lifecycle';

const routeMap: Record<string, Route> = {
  '/': 'landing',
  '/debugger': 'debugger',
  '/s3-explorer': 's3-explorer',
  '/ddb-viewer': 'ddb-viewer',
  '/log-explorer': 'log-explorer',
  '/sqs-monitor': 'sqs-monitor',
  '/lambda-inspector': 'lambda-inspector',
  '/health-dashboard': 'health-dashboard',
  '/strategy-lifecycle': 'strategy-lifecycle',
};

const pathMap: Record<Route, string> = Object.fromEntries(
  Object.entries(routeMap).map(([path, route]) => [route, `#${path}`])
) as Record<Route, string>;

function getRouteFromHash(): Route {
  const hash = window.location.hash.slice(1) || '/';
  return routeMap[hash] || 'landing';
}

export const currentRoute = writable<Route>(
  typeof window !== 'undefined' ? getRouteFromHash() : 'landing'
);

if (typeof window !== 'undefined') {
  window.addEventListener('hashchange', () => {
    currentRoute.set(getRouteFromHash());
  });
}

export function navigate(route: Route) {
  window.location.hash = pathMap[route];
}

export function goHome() {
  navigate('landing');
}
